import { create } from 'zustand';
import { ReferralBenefitResultType } from '@/shared/types/sign/sign-in-social';

interface ReferralBenefitStore {
  benefitResult: ReferralBenefitResultType | null;
}

interface ReferralBenefitStoreActions {
  setBenefitResult: (result: ReferralBenefitResultType) => void;
  clearBenefitResult: () => void;
}

export const useReferralBenefitStore = create<
  ReferralBenefitStore & ReferralBenefitStoreActions
>()((set) => ({
  benefitResult: null,
  setBenefitResult: (result: ReferralBenefitResultType) =>
    set({ benefitResult: result }),
  clearBenefitResult: () => set({ benefitResult: null }),
}));
